exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.router-link-exact-active.router-link-active[data-v-5a01a2fe]{\n    color: #ffffff !important;\n}\n.router-link-exact-active.router-link-active i[data-v-5a01a2fe]{\n    color: #ffffff !important;\n}\n", ""]);

// exports
